import GamesMessagesEntity from './GamesMessages.entity';

export const gamesMessagesEntity = new GamesMessagesEntity();

export * from './enums';
export * from './interfaces';
